
import React, { useState } from 'react';
import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import { Container, Row, Col, Offcanvas, Button } from 'react-bootstrap';
// import '../Assets/Css/Donationdetails.css';
import AdminFooter from '../Components/AdminFooter';
import GalleryData from './GalleryData';

export default function Gallery() {
  const [showSidebar, setShowSidebar] = useState(false);

  const handleClose = () => setShowSidebar(false);
  const handleShow = () => setShowSidebar(true);

  return (
    <div className=" min-vh-100">

      <Container fluid className="p-0">
        <Row className="g-0">

          {/* Offcanvas Sidebar for Mobile */}
          <Offcanvas show={showSidebar} onHide={handleClose} responsive="md">
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>Menu</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Sidebar />
            </Offcanvas.Body>
          </Offcanvas>

          {/* Sidebar for Desktop */}
          <Col md={2} className="d-none d-md-block sidebar-wrapper">
            <Sidebar />
          </Col>

          {/* Main Content */}
          <Col xs={12} md={10} className="main-content-wrapper">
            {/* Show toggle button on mobile */}
            <div className="d-md-none p-2">
              <Button variant="primary" onClick={handleShow}>
                ☰ Menu
              </Button>
            </div>

            <Topbar />
            <GalleryData />
          </Col>
        </Row>
      </Container>
      <AdminFooter />
    </div>

  );
}
